module.exports = __webpack_public_path__ + "e4201af5be7468c0b49a5f353b47ce28.png";